import { runtimeEnv } from '@/config/runtime-env';
/**
 * Feature flags for controlling system features
 * This allows gradual rollout and easy rollback of new features
 */

export const featureFlags = {
  /**
   * Controls whether to use the new favicon extraction and caching system
   * When true: Uses new edge function with WebP optimization and smart caching
   * When false: Falls back to legacy favicon service
   */
  useNewFaviconSystem: runtimeEnv.NEXT_PUBLIC_USE_NEW_FAVICON,
  
  /**
   * Controls whether to use Iconify library for platform icons
   * When true: Uses Iconify with 500+ real brand icons and 5 style variations
   * When false: Uses existing Lucide icon system
   */
  useIconifyLibrary: runtimeEnv.NEXT_PUBLIC_USE_ICONIFY_LIBRARY
};

// Helper function to check if a feature is enabled
export function isFeatureEnabled(feature: keyof typeof featureFlags): boolean {
  return featureFlags[feature] === true;
}

// Log feature flag status for debugging
if (typeof window !== 'undefined') {
  console.log('[Feature Flags] New Favicon System:', featureFlags.useNewFaviconSystem);
  console.log('[Feature Flags] Iconify Library:', featureFlags.useIconifyLibrary);
}
